import React from 'react';
import { QuestionType } from '@domain/constant/questionType';
import { useInterview } from '@components/pass/interview/start/context/interviewContext';
import { useUserInfo } from '@repository/auth/useUserInfo';
import Icon from '@components/common/assets';
import Colors from '@domain/constant/colors';
import style from './tab.module.scss';
import classnames from 'classnames/bind';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';
import { useAffilliateCertificationStatus } from '@repository/partnership/usePartnership';

const cx = classnames.bind(style);

interface MockTabCategoryVO {
  text: string;
  type: QuestionType;
  enable: boolean;
}

const InterviewPracticeQuestionSelectTab = () => {
  const { activeTab, setActiveTab } = useInterview();
  const { data: userInfo } = useUserInfo();
  const { data } = useAffilliateCertificationStatus({ enabled: !!userInfo?.id });
  const isNotView = ['서울시', '경기도교육청 취업지원센터'].includes(data?.organizationInfo?.organizationName ?? '');

  const isActive = (type: QuestionType) => {
    return activeTab === type;
  };

  return (
    <div className={cx('tabWrap')}>
      <div className={cx('tabMenu')}>
        <button
          className={cx('tab', { active: isActive(QuestionType.COMPANY) })}
          onClick={() => setActiveTab(QuestionType.COMPANY)}
        >
          기업별 질문
        </button>
        <button
          className={cx('tab', { active: isActive(QuestionType.FREQUENCY) })}
          onClick={() => setActiveTab(QuestionType.FREQUENCY)}
        >
          빈출 면접 질문
        </button>
        {!isNotView && (
          <button
            className={cx('tab', 'newTab', { active: isActive(QuestionType.ACC) })}
            onClick={() => setActiveTab(QuestionType.ACC)}
          >
            역량검사 결과 기반 질문
          </button>
        )}
        <button
          className={cx('tab', { active: isActive(QuestionType.MYSELF) })}
          onClick={() => setActiveTab(QuestionType.MYSELF)}
        >
          내가 만든 질문
        </button>
      </div>
    </div>
  );
};

export default InterviewPracticeQuestionSelectTab;
